import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            全网最热的追剧话题都在这里，加入讨论一起聊
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5 md:gap-3">
          {topicsData.map((topic, idx) => (
            <a
              key={topic.id}
              href="#topics"
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all whitespace-nowrap ${
                idx < 3
                  ? 'bg-primary-100 border-primary-200 text-primary-700 hover:bg-primary-200'
                  : idx < 6
                    ? 'bg-accent-100 border-accent-200 text-accent-700 hover:bg-accent-200'
                    : 'bg-secondary-100 border-secondary-200 text-secondary-700 hover:bg-secondary-200'
              }`}
            >
              <span className="text-xs md:text-sm font-semibold">{topic.name}</span>
              <span className="text-[10px] md:text-xs opacity-70">{topic.hot}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}